import selection1Img from '../assets/images/selection/selection1.jpg'
import selection2Img from '../assets/images/selection/selection2.jpeg'
import selection3Img from '../assets/images/selection/selection3.jpg'
import selection4Img from '../assets/images/selection/selection4.jpg'
import selection5Img from '../assets/images/selection/selection5.jpg'
import selection6Img from '../assets/images/selection/selection6.jpg'
import selection7Img from '../assets/images/selection/selection7.jpg'
import selection8Img from '../assets/images/selection/selection8.jpg'
import selection9Img from '../assets/images/selection/selection9.jpg'
import selection10Img from '../assets/images/selection/selection10.jpg'
import selection11Img from '../assets/images/selection/selection11.jpg'
import selection12Img from '../assets/images/selection/selection12.jpg'
import selection13Img from '../assets/images/selection/selection13.jpg'
import selection14Img from '../assets/images/selection/selection14.jpg'
import selection15Img from '../assets/images/selection/selection15.jpg'
import selection16Img from '../assets/images/selection/selection16.jpg'
import selection17Img from '../assets/images/selection/selection17.jpg'
import selection18Img from '../assets/images/selection/selection18.jpg'
import selection19Img from '../assets/images/selection/selection19.jpg'
import selection20Img from '../assets/images/selection/selection20.jpg'
import selection21Img from '../assets/images/selection/selection21.jpg'
import selection22Img from '../assets/images/selection/selection22.jpg'
import selection23Img from '../assets/images/selection/selection23.jpg'
import selection24Img from '../assets/images/selection/selection24.jpg'
import selection25Img from '../assets/images/selection/selection25.jpg'
import selection26Img from '../assets/images/selection/selection26.jpg'
import selection27Img from '../assets/images/selection/selection27.jpg'
import selection28Img from '../assets/images/selection/selection28.jpg'
import selection29Img from '../assets/images/selection/selection29.jpg'
import selection30Img from '../assets/images/selection/selection30.jpg'
import selection31Img from '../assets/images/selection/selection31.jpg'
import selection32Img from '../assets/images/selection/selection32.jpg'
import selection33Img from '../assets/images/selection/selection33.jpg'
import selection34Img from '../assets/images/selection/selection34.jpg'
import selection35Img from '../assets/images/selection/selection35.jpg'
import selection36Img from '../assets/images/selection/selection36.jpg'
import selection37Img from '../assets/images/selection/selection37.jpg'
import selection38Img from '../assets/images/selection/selection38.jpg'
import selection39Img from '../assets/images/selection/selection39.jpg'
import selection40Img from '../assets/images/selection/selection40.jpg'
import selection41Img from '../assets/images/selection/selection41.jpg'
import selection42Img from '../assets/images/selection/selection42.jpg'
import selection43Img from '../assets/images/selection/selection43.jpg'
import selection44Img from '../assets/images/selection/selection44.jpg'
import selection45Img from '../assets/images/selection/selection45.jpg'
import selection46Img from '../assets/images/selection/selection46.jpg'
import selection47Img from '../assets/images/selection/selection47.jpg'
import selection48Img from '../assets/images/selection/selection48.jpg'
import selection49Img from '../assets/images/selection/selection49.jpg'
import selection50Img from '../assets/images/selection/selection50.jpg'
import selection51Img from '../assets/images/selection/selection51.jpg'
import selection52Img from '../assets/images/selection/selection52.jpg'
import selection54Img from '../assets/images/selection/selection54.jpg'
import selection55Img from '../assets/images/selection/selection55.jpg'
import selection56Img from '../assets/images/selection/selection56.jpg'
import selection57Img from '../assets/images/selection/selection57.jpg'
import selection59Img from '../assets/images/selection/selection59.jpg'
import selection60Img from '../assets/images/selection/selection60.jpg'
import selection61Img from '../assets/images/selection/selection61.jpg'
import selection62Img from '../assets/images/selection/selection62.jpg'
import selection63Img from '../assets/images/selection/selection63.jpg'
import selection64Img from '../assets/images/selection/selection64.jpg'
import selection65Img from '../assets/images/selection/selection65.jpg'
import selection66Img from '../assets/images/selection/selection66.jpg'
import selection67Img from '../assets/images/selection/selection67.jpg'
import selection68Img from '../assets/images/selection/selection68.jpg'
import selection69Img from '../assets/images/selection/selection69.jpg'
import selection70Img from '../assets/images/selection/selection70.jpg'
import selection71Img from '../assets/images/selection/selection71.jpg'
import selection72Img from '../assets/images/selection/selection72.jpg'
import selection73Img from '../assets/images/selection/selection73.jpg'
import selection74Img from '../assets/images/selection/selection74.jpg'
import selection75Img from '../assets/images/selection/selection75.jpg'
import selection76Img from '../assets/images/selection/selection76.jpg'
import selection77Img from '../assets/images/selection/selection77.jpg'
import selection78Img from '../assets/images/selection/selection78.jpg'
import selection79Img from '../assets/images/selection/selection79.jpg'
import selection80Img from '../assets/images/selection/selection80.jpg'
import selection81Img from '../assets/images/selection/selection81.jpg'
import selection82Img from '../assets/images/selection/selection82.jpg'
import selection83Img from '../assets/images/selection/selection83.jpg'
import selection84Img from '../assets/images/selection/selection84.jpg'
import selection85Img from '../assets/images/selection/selection85.jpg'
import selection86Img from '../assets/images/selection/selection86.jpg'
import selection87Img from '../assets/images/selection/selection87.jpg'
import selection88Img from '../assets/images/selection/selection88.jpg'
import selection89Img from '../assets/images/selection/selection89.jpg'
import selection90Img from '../assets/images/selection/selection90.jpg'
import selection91Img from '../assets/images/selection/selection91.jpg'
import selection92Img from '../assets/images/selection/selection92.jpg'
import selection93Img from '../assets/images/selection/selection93.jpg'
import selection94Img from '../assets/images/selection/selection94.jpg'
import selection95Img from '../assets/images/selection/selection95.jpg'
import img2 from '../assets/images/selection/top/selection2.jpg'
import img3 from '../assets/images/selection/top/selection3.jpg'
import img18 from '../assets/images/selection/top/selection18.jpg'
import img19 from '../assets/images/selection/top/selection19.jpg'
import img24 from '../assets/images/selection/top/selection24.jpg'
import img33 from '../assets/images/selection/top/selection33.jpg'
import img40 from '../assets/images/selection/top/selection40.jpg'
import selection11thematic6Img from '../assets/images/thematicSelections/11/buninskiye.jpg'
import selection11thematic3Img from '../assets/images/thematicSelections/11/lyublinskiy.jpg'
import selection11thematic4Img from '../assets/images/thematicSelections/11/myakinino.jpg'
import selection11thematic5Img from '../assets/images/thematicSelections/11/ochakovskaya.jpg'
import selection11thematic1Img from '../assets/images/thematicSelections/11/orangePark.jpg'
import selection11thematic2Img from '../assets/images/thematicSelections/11/vtoroy.jpg'
import selection14thematic4Img from '../assets/images/thematicSelections/14/layouts.jpg'
import selection14thematic3Img from '../assets/images/thematicSelections/14/peculiarities.jpg'
import selection14thematic1Img from '../assets/images/thematicSelections/14/whathappened.jpg'
import selection14thematic2Img from '../assets/images/thematicSelections/14/yieldprograms.jpg'
import selection16thematic7Img from '../assets/images/thematicSelections/16/akademikaPavlova.jpg'
import selection16thematic1Img from '../assets/images/thematicSelections/16/buninMeadows.jpg'
import selection16thematic8Img from '../assets/images/thematicSelections/16/dmitrovskyPark.jpg'
import selection16thematic2Img from '../assets/images/thematicSelections/16/greenPark.jpg'
import selection16thematic9Img from '../assets/images/thematicSelections/16/lefortovoPark.jpg'
import selection16thematic5Img from '../assets/images/thematicSelections/16/meshcherskiyLes.jpg'
import selection16thematic6Img from '../assets/images/thematicSelections/16/odintsovo1.jpg'
import selection16thematic3Img from '../assets/images/thematicSelections/16/salaryevoPark.jpg'
import selection16thematic10Img from '../assets/images/thematicSelections/16/vanderPark.jpg'
import selection16thematic4Img from '../assets/images/thematicSelections/16/yasenevaya14.jpg'
import selection17thematic4Img from '../assets/images/thematicSelections/17/1.jpg'
import selection17thematic3Img from '../assets/images/thematicSelections/17/2.jpg'
import selection17thematic1Img from '../assets/images/thematicSelections/17/3.jpg'
import selection17thematic2Img from '../assets/images/thematicSelections/17/4.jpg'
import selection25thematic1Img from '../assets/images/thematicSelections/25/1.jpg'
import selection25thematic2Img from '../assets/images/thematicSelections/25/2.jpg'
import selection25thematic3Img from '../assets/images/thematicSelections/25/3.jpg'
import selection25thematic4Img from '../assets/images/thematicSelections/25/4.jpg'
import selection25thematic5Img from '../assets/images/thematicSelections/25/5.jpg'
import selection28thematic1Img from '../assets/images/thematicSelections/28/1.jpg'
import selection28thematic2Img from '../assets/images/thematicSelections/28/2.jpg'
import selection28thematic3Img from '../assets/images/thematicSelections/28/3.jpg'
import selection38thematic1Img from '../assets/images/thematicSelections/38/1.jpg'
import selection38thematic2Img from '../assets/images/thematicSelections/38/2.jpg'
import selection38thematic3Img from '../assets/images/thematicSelections/38/3.jpg'
import selection38thematic4Img from '../assets/images/thematicSelections/38/4.jpg'
import selection38thematic5Img from '../assets/images/thematicSelections/38/5.jpg'
import selection38thematic6Img from '../assets/images/thematicSelections/38/6.jpg'
import selection45thematic4Img from '../assets/images/thematicSelections/45/4.jpg'
import selection45thematic6Img from '../assets/images/thematicSelections/45/6.jpg'
import selection48thematic1Img from '../assets/images/thematicSelections/48/1.jpg'
import selection48thematic2Img from '../assets/images/thematicSelections/48/2.jpg'
import selection48thematic3Img from '../assets/images/thematicSelections/48/3.jpg'
import selection48thematic4Img from '../assets/images/thematicSelections/48/4.jpg'
import selection52thematic1Img from '../assets/images/thematicSelections/52/1.jpg'
import selection52thematic2Img from '../assets/images/thematicSelections/52/2.jpg'
import selection52thematic3Img from '../assets/images/thematicSelections/52/3.jpg'
import selection52thematic4Img from '../assets/images/thematicSelections/52/4.jpg'
import selection52thematic5Img from '../assets/images/thematicSelections/52/5.jpg'
import selection57thematic1Img from '../assets/images/thematicSelections/57/1.jpg'
import selection57thematic2Img from '../assets/images/thematicSelections/57/2.jpg'
import selection57thematic3Img from '../assets/images/thematicSelections/57/3.jpg'
import selection57thematic4Img from '../assets/images/thematicSelections/57/4.jpg'
import selection57thematic5Img from '../assets/images/thematicSelections/57/5.jpg'
import selection58thematic1Img from '../assets/images/thematicSelections/58/1.jpg'
import selection58thematic2Img from '../assets/images/thematicSelections/58/2.jpg'
import selection58thematic3Img from '../assets/images/thematicSelections/58/3.jpg'
import selection62thematic1Img from '../assets/images/thematicSelections/62/1.jpg'
import selection62thematic2Img from '../assets/images/thematicSelections/62/2.jpg'
import selection62thematic3Img from '../assets/images/thematicSelections/62/3.jpg'
import selection62thematic4Img from '../assets/images/thematicSelections/62/4.jpg'
import selection62thematic5Img from '../assets/images/thematicSelections/62/5.jpg'
import selection62thematic6Img from '../assets/images/thematicSelections/62/6.jpg'
import selection62thematic7Img from '../assets/images/thematicSelections/62/7.jpg'
import selection62thematic8Img from '../assets/images/thematicSelections/62/8.jpg'
import selection62thematic9Img from '../assets/images/thematicSelections/62/9.jpg'
import selection62thematic10Img from '../assets/images/thematicSelections/62/10.jpg'
import selection62thematic11Img from '../assets/images/thematicSelections/62/11.jpg'
import selection62thematic12Img from '../assets/images/thematicSelections/62/12.jpg'
import selection62thematic13Img from '../assets/images/thematicSelections/62/13.jpg'
import selection62thematic14Img from '../assets/images/thematicSelections/62/14.jpg'
import selection62thematic15Img from '../assets/images/thematicSelections/62/15.jpg'
import selection62thematic16Img from '../assets/images/thematicSelections/62/16.jpg'
import selection62thematic17Img from '../assets/images/thematicSelections/62/17.jpg'
import selection62thematic18Img from '../assets/images/thematicSelections/62/18.jpg'
import selection62thematic19Img from '../assets/images/thematicSelections/62/19.jpg'
import selection62thematic20Img from '../assets/images/thematicSelections/62/20.jpg'
import selection64thematic1Img1 from '../assets/images/thematicSelections/64/1-1.jpg'
import selection64thematic1Img2 from '../assets/images/thematicSelections/64/1-2.jpg'
import selection64thematic1Img3 from '../assets/images/thematicSelections/64/1-3.jpg'
import selection64thematic2Img1 from '../assets/images/thematicSelections/64/2-1.jpg'
import selection64thematic2Img2 from '../assets/images/thematicSelections/64/2-2.jpg'
import selection64thematic2Img3 from '../assets/images/thematicSelections/64/2-3.jpg'
import selection64thematic3Img1 from '../assets/images/thematicSelections/64/3-1.jpg'
import selection64thematic3Img2 from '../assets/images/thematicSelections/64/3-2.jpg'
import selection65thematic1Img from '../assets/images/thematicSelections/65/1.jpg'
import selection65thematic2Img from '../assets/images/thematicSelections/65/2.jpg'
import selection65thematic3Img from '../assets/images/thematicSelections/65/3.jpg'
import selection65thematic4Img from '../assets/images/thematicSelections/65/4.jpg'
import selection65thematic5Img from '../assets/images/thematicSelections/65/5.jpg'
import selection65thematic6Img from '../assets/images/thematicSelections/65/6.jpg'
import selection68thematic1Img from '../assets/images/thematicSelections/68/1.jpg'
import selection68thematic2Img from '../assets/images/thematicSelections/68/2.jpg'
import selection68thematic3Img from '../assets/images/thematicSelections/68/3.jpg'
import selection73thematic1Img1 from '../assets/images/thematicSelections/73/1-1.jpg'
import selection73thematic1Img2 from '../assets/images/thematicSelections/73/1-2.jpg'
import selection73thematic1Img3 from '../assets/images/thematicSelections/73/1-3.jpg'
import selection73thematic1Img4 from '../assets/images/thematicSelections/73/1-4.jpg'
import selection73thematic1Img5 from '../assets/images/thematicSelections/73/1-5.jpg'
import selection73thematic1Img6 from '../assets/images/thematicSelections/73/1-6.jpg'
import selection73thematic1Img7 from '../assets/images/thematicSelections/73/1-7.jpg'
import selection73thematic2Img from '../assets/images/thematicSelections/73/2.jpg'
import selection73thematic3Img1 from '../assets/images/thematicSelections/73/3-1.jpg'
import selection73thematic3Img2 from '../assets/images/thematicSelections/73/3-2.jpg'
import selection73thematic3Img3 from '../assets/images/thematicSelections/73/3-3.jpg'
import selection73thematic4Img from '../assets/images/thematicSelections/73/4.jpg'
import selection73thematic5Img1 from '../assets/images/thematicSelections/73/5-1.jpg'
import selection73thematic5Img2 from '../assets/images/thematicSelections/73/5-2.jpg'
import selection73thematic6Img1 from '../assets/images/thematicSelections/73/6-1.jpg'
import selection73thematic6Img2 from '../assets/images/thematicSelections/73/6-2.jpg'
import selection73thematic6Img3 from '../assets/images/thematicSelections/73/6-3.jpg'
import selection73thematic6Img4 from '../assets/images/thematicSelections/73/6-4.jpg'
import selection73thematic7Img1 from '../assets/images/thematicSelections/73/7-1.jpg'
import selection73thematic7Img2 from '../assets/images/thematicSelections/73/7-2.jpg'
import selection73thematic7Img3 from '../assets/images/thematicSelections/73/7-3.jpg'
import selection73thematic7Img4 from '../assets/images/thematicSelections/73/7-4.jpg'
import selection73thematic7Img5 from '../assets/images/thematicSelections/73/7-5.jpg'
import selection73thematic8Img1 from '../assets/images/thematicSelections/73/8-1.jpg'
import selection73thematic8Img2 from '../assets/images/thematicSelections/73/8-2.jpg'
import selection73thematic8Img3 from '../assets/images/thematicSelections/73/8-3.jpg'
import selection73thematic8Img4 from '../assets/images/thematicSelections/73/8-4.jpg'
import selection73thematic9Img1 from '../assets/images/thematicSelections/73/9-1.jpg'
import selection73thematic9Img2 from '../assets/images/thematicSelections/73/9-2.jpg'
import selection73thematic9Img3 from '../assets/images/thematicSelections/73/9-3.jpg'
import selection73thematic9Img4 from '../assets/images/thematicSelections/73/9-4.jpg'
import selection76thematic1Img from '../assets/images/thematicSelections/76/1.jpg'
import selection76thematic2Img from '../assets/images/thematicSelections/76/2.jpg'
import selection76thematic3Img from '../assets/images/thematicSelections/76/3.jpg'
import selection76thematic4Img from '../assets/images/thematicSelections/76/4.jpg'
import selection76thematic5Img from '../assets/images/thematicSelections/76/5.jpg'
import selection76thematic6Img from '../assets/images/thematicSelections/76/6.jpg'

export const selectionImages = {
  1: selection1Img,
  2: selection2Img,
  3: selection3Img,
  4: selection4Img,
  5: selection5Img,
  6: selection6Img,
  7: selection7Img,
  8: selection8Img,
  9: selection9Img,
  10: selection10Img,
  11: selection11Img,
  12: selection12Img,
  13: selection13Img,
  14: selection14Img,
  15: selection15Img,
  16: selection16Img,
  17: selection17Img,
  18: selection18Img,
  19: selection19Img,
  20: selection20Img,
  21: selection21Img,
  22: selection22Img,
  23: selection23Img,
  24: selection24Img,
  25: selection25Img,
  26: selection26Img,
  27: selection27Img,
  28: selection28Img,
  29: selection29Img,
  30: selection30Img,
  31: selection31Img,
  32: selection32Img,
  33: selection33Img,
  34: selection34Img,
  35: selection35Img,
  36: selection36Img,
  37: selection37Img,
  38: selection38Img,
  39: selection39Img,
  40: selection40Img,
  41: selection41Img,
  42: selection42Img,
  43: selection43Img,
  44: selection44Img,
  45: selection45Img,
  46: selection46Img,
  47: selection47Img,
  48: selection48Img,
  49: selection49Img,
  50: selection50Img,
  51: selection51Img,
  52: selection52Img,
  54: selection54Img,
  55: selection55Img,
  56: selection56Img,
  57: selection57Img,
  59: selection59Img,
  60: selection60Img,
  61: selection61Img,
  62: selection62Img,
  63: selection63Img,
  64: selection64Img,
  65: selection65Img,
  66: selection66Img,
  67: selection67Img,
  68: selection68Img,
  69: selection69Img,
  70: selection70Img,
  71: selection71Img,
  72: selection72Img,
  73: selection73Img,
  74: selection74Img,
  75: selection75Img,
  76: selection76Img,
  77: selection77Img,
  78: selection78Img,
  79: selection79Img,
  80: selection80Img,
  81: selection81Img,
  82: selection82Img,
  83: selection83Img,
  84: selection84Img,
  85: selection85Img,
  86: selection86Img,
  87: selection87Img,
  88: selection88Img,
  89: selection89Img,
  90: selection90Img,
  91: selection91Img,
  92: selection92Img,
  93: selection93Img,
  94: selection94Img,
  95: selection95Img,
}

export const selectionImagesTop = {
  2: img2,
  3: img3,
  18: img18,
  19: img19,
  24: img24,
  33: img33,
  40: img40,
}

export const thematicImages = {
  1: selection11thematic1Img,
  2: selection11thematic2Img,
  3: selection11thematic3Img,
  4: selection11thematic4Img,
  5: selection11thematic5Img,
  6: selection11thematic6Img,
}

export const thematicImages14 = {
  1: selection14thematic1Img,
  2: selection14thematic2Img,
  3: selection14thematic3Img,
  4: selection14thematic4Img,
}

export const thematicImages16 = {
  1: selection16thematic1Img,
  2: selection16thematic2Img,
  3: selection16thematic3Img,
  4: selection16thematic4Img,
  5: selection16thematic5Img,
  6: selection16thematic6Img,
  7: selection16thematic7Img,
  8: selection16thematic8Img,
  9: selection16thematic9Img,
  10: selection16thematic10Img,
}

export const thematicImages17 = {
  1: selection17thematic1Img,
  2: selection17thematic2Img,
  3: selection17thematic3Img,
  4: selection17thematic4Img,
}

export const thematicImages25 = {
  1: selection25thematic1Img,
  2: selection25thematic2Img,
  3: selection25thematic3Img,
  4: selection25thematic4Img,
  5: selection25thematic5Img,
}

export const thematicImages28 = {
  1: selection28thematic1Img,
  2: selection28thematic2Img,
  3: selection28thematic3Img,
}

export const thematicImages38 = {
  1: selection38thematic1Img,
  2: selection38thematic2Img,
  3: selection38thematic3Img,
  4: selection38thematic4Img,
  5: selection38thematic5Img,
  6: selection38thematic6Img,
}

export const thematicImages45 = {
  4: selection45thematic4Img,
  6: selection45thematic6Img,
}

export const thematicImages48 = {
  1: selection48thematic1Img,
  2: selection48thematic2Img,
  3: selection48thematic3Img,
  4: selection48thematic4Img,
}

export const thematicImages52 = {
  1: selection52thematic1Img,
  2: selection52thematic2Img,
  3: selection52thematic3Img,
  4: selection52thematic4Img,
  5: selection52thematic5Img,
}

export const thematicImages57 = {
  1: selection57thematic1Img,
  2: selection57thematic2Img,
  3: selection57thematic3Img,
  4: selection57thematic4Img,
  5: selection57thematic5Img,
}

export const thematicImages58 = {
  1: selection58thematic1Img,
  2: selection58thematic2Img,
  3: selection58thematic3Img,
}

export const thematicImages62 = {
  1: selection62thematic1Img,
  2: selection62thematic2Img,
  3: selection62thematic3Img,
  4: selection62thematic4Img,
  5: selection62thematic5Img,
  6: selection62thematic6Img,
  7: selection62thematic7Img,
  8: selection62thematic8Img,
  9: selection62thematic9Img,
  10: selection62thematic10Img,
  11: selection62thematic11Img,
  12: selection62thematic12Img,
  13: selection62thematic13Img,
  14: selection62thematic14Img,
  15: selection62thematic15Img,
  16: selection62thematic16Img,
  17: selection62thematic17Img,
  18: selection62thematic18Img,
  19: selection62thematic19Img,
  20: selection62thematic20Img,
}

export const thematicImages64 = {
  1: [
    selection64thematic1Img2,
    selection64thematic1Img1,
    selection64thematic1Img3,
  ],
  2: [
    selection64thematic2Img3,
    selection64thematic2Img1,
    selection64thematic2Img2,
  ],
  3: [selection64thematic3Img1, selection64thematic3Img2],
}

export const thematicImages65 = {
  1: selection65thematic1Img,
  2: selection65thematic2Img,
  3: selection65thematic3Img,
  4: selection65thematic4Img,
  5: selection65thematic5Img,
  6: selection65thematic6Img,
}

export const thematicImages68 = {
  1: selection68thematic1Img,
  2: selection68thematic2Img,
  3: selection68thematic3Img,
}

export const thematicImages73 = {
  1: [
    selection73thematic1Img1,
    selection73thematic1Img2,
    selection73thematic1Img3,
    selection73thematic1Img4,
    selection73thematic1Img5,
    selection73thematic1Img6,
    selection73thematic1Img7,
  ],
  2: selection73thematic2Img,
  3: [
    selection73thematic3Img1,
    selection73thematic3Img2,
    selection73thematic3Img3,
  ],
  4: selection73thematic4Img,
  5: [selection73thematic5Img1, selection73thematic5Img2],
  6: [
    selection73thematic6Img1,
    selection73thematic6Img2,
    selection73thematic6Img3,
    selection73thematic6Img4,
  ],
  7: [
    selection73thematic7Img1,
    selection73thematic7Img2,
    selection73thematic7Img3,
    selection73thematic7Img4,
    selection73thematic7Img5,
  ],
  8: [
    selection73thematic8Img1,
    selection73thematic8Img2,
    selection73thematic8Img3,
    selection73thematic8Img4,
  ],
  9: [
    selection73thematic9Img1,
    selection73thematic9Img2,
    selection73thematic9Img3,
    selection73thematic9Img4,
  ],
}

export const thematicImages76 = {
  1: selection76thematic1Img,
  2: selection76thematic2Img,
  3: selection76thematic3Img,
  4: selection76thematic4Img,
  5: selection76thematic5Img,
  6: selection76thematic6Img,
}
